module.exports = __webpack_public_path__ + "img/metal_am@2x.a22b1266.png";